import { useState } from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      text: 'El pavimento de hormigón impreso que nos instalaron superó todas nuestras expectativas. El acabado es impecable y la atención al detalle excepcional. Totalmente recomendables.',
      author: 'María González',
      location: 'Estepona',
      image: 'https://public.readdy.ai/ai/img_res/977c5a9dfdaadb4d30d75d367794e2d3.jpg',
    },
    {
      text: 'Nuestra piscina Arelite es el sueño hecho realidad. El efecto playa es increíble y la calidad del trabajo impresionante. El equipo fue muy profesional en todo momento.',
      author: 'Carlos Martínez',
      location: 'Marbella',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20male%20customer%20smiling%20in%20luxury%20home%20with%20natural%20lighting%20warm%20tones%20professional%20photography&width=600&height=800&seq=testimonial-002&orientation=portrait',
    },
    {
      text: 'Contratamos hormigón desactivado para nuestra comunidad y el resultado es fantástico. Muy resistente y con un aspecto natural que nos encanta. Excelente servicio.',
      author: 'Ana Rodríguez',
      location: 'Manilva',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20satisfied%20female%20customer%20smiling%20in%20elegant%20home%20with%20natural%20lighting%20warm%20tones%20professional%20photography&width=600&height=800&seq=testimonial-003&orientation=portrait',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <div className="rounded-3xl overflow-hidden h-96 lg:h-[500px]">
              <img
                src={current.image}
                alt={current.author}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-secondary text-sm mb-3">(Lo que dicen nuestros clientes)</p>
            <h2 className="text-5xl font-bold mb-16">
              Trabajos que hablan{' '}
              <span className="text-gray-300">por sí mismos</span>
            </h2>

            <div className="mb-8">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className="ri-double-quotes-l text-5xl text-primary/20"></i>
              </div>
              <p className="text-xl text-dark leading-relaxed mb-6">
                {current.text}
              </p>
              <p className="text-lg font-bold text-dark">
                — {current.author}, {current.location}
              </p>
            </div>

            <div className="flex gap-4">
              <button
                onClick={prevTestimonial}
                className="w-12 h-12 flex items-center justify-center border border-gray-300 rounded-full hover:border-primary hover:text-primary transition-colors cursor-pointer"
                aria-label="Anterior testimonio"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <button
                onClick={nextTestimonial}
                className="w-12 h-12 flex items-center justify-center bg-primary text-white rounded-full hover:bg-[#1873CC] transition-colors cursor-pointer"
                aria-label="Siguiente testimonio"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;